export const CONTENT_FILTER = ['Venue Partners', 'Video Walkthrough', '360 Tour'];
